module.exports = __webpack_public_path__ + "static/Q3_2022_Investor_call_Dial-in-information-a4c50a61ef8a5d03e9215432a758e5db.pdf";